import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/customerprofile/company-info`;

const listAll = async () => {
  const res = await axios.get(API_URL);
  return res.data;
};

const getByCustomerId = async (customerId) => {
  const res = await axios.get(`${API_URL}/${customerId}`);
  return res.data;
};

const upsert = async ({ customerId, taxNo, companyName, companyAddress }) => {
  const res = await axios.post(API_URL, { customerId, taxNo, companyName, companyAddress });
  return res.data;
};

const remove = async (customerId) => {
  const res = await axios.delete(`${API_URL}/${customerId}`);
  return res.data;
};

export default {
  listAll,
  getByCustomerId,
  upsert,
  remove,
};

